import styles from './styles.module.scss';

export default function Banco({ p, deletarMembro,editar }) {
  return (
    <div className={styles.card}>
      <h3 className={styles.title}>{p.nome}</h3>
      <h3 className={styles.title}>{p.perguntas.length}</h3>
      <button onClick={() => deletarMembro(p.id)} className={styles.delete}>
        Deletar
      </button>
      <button onClick={() => editar(p)} className={`${styles.editar}`}>
        Editar
      </button>
    </div>
  );
}
